import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ContainerOutlined, UsbOutlined } from '@ant-design/icons';
import { translate } from '@smovilgps/optimus-intl';
import { Tabs } from 'antd-v6';
import StripePlans from '../stripePlans';
import Models from '.';

const ModelStripePlanPage = () => {
	const items = [
		{
			label: (
				<span className="tab-label">
					<UsbOutlined />
					<FormattedMessage {...translate('models')} />
				</span>
			),
			key: '1',
			children: <Models />,
		},
		{
			label: (
				<span className="tab-label">
					<ContainerOutlined />
					<FormattedMessage {...translate('stripePlans')} />
				</span>
			),
			key: '2',
			children: <StripePlans />,
		},
	];

	return (
		<div className="view">
			<Tabs items={items} />
		</div>
	);
};

export default ModelStripePlanPage;
